import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IWorkState } from ".";
import { IWorkProp } from "./get-work.handler";
import { WorkProp } from "../../pages/WorkUpgradePage/WorkUpgradePage";

export interface IUpgradeWorkResponse {
    balance: number;
    exp: number;
    capacity?: IWorkProp;
    profitRate?: IWorkProp;
    storeSpeed?: IWorkProp;
};

export const upgradeWork = createAsyncThunk<IUpgradeWorkResponse, WorkProp>(
    'work/upgradeWork',
    async (workProp: WorkProp) => await api.work.upgradeWork(workProp)
);

const upgradeWorkHandler = (builder: ActionReducerMapBuilder<IWorkState>) => {
    builder
        .addCase(upgradeWork.pending, (state: IWorkState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(upgradeWork.fulfilled, (state: IWorkState, action: PayloadAction<IUpgradeWorkResponse>) => {
            state.loading = false;
            
            if (action.payload.capacity) {
                state.capacity = action.payload.capacity;
                state.lastConvertDate = 0;
            }
            else if (action.payload.profitRate)
                state.profitRate = action.payload.profitRate;
            else if (action.payload.storeSpeed)
                state.storeSpeed = action.payload.storeSpeed;
        })
        .addCase(upgradeWork.rejected, (state: IWorkState) => {
            state.loading = false;
            state.error = 'Unable to upgrade work';
        });
};

export default upgradeWorkHandler;